import { request } from './apiClient';
import authStorage from '../utils/authStorage';

export const authService = {
  registerRequestOtp: async (emailId, mobileNo) => {
    return request('/auth/register/request-otp', {
      method: 'POST',
      body: JSON.stringify({ emailId, mobileNo })
    });
  },

  register: async (userData) => {
    return request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({
        ...userData,
        roles: userData.roles || ["USER"]
      }),
    });
  },

  login: async (credentials) => {
    const result = await request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });

    if (result.success && result.data.accessToken) {
      authStorage.setItem('token', result.data.accessToken);
      authStorage.setItem('refreshToken', result.data.refreshToken);
      authStorage.setItem('user', JSON.stringify(result.data.user || { username: credentials.username }));
    }
    return result;
  },

  logout: () => {
    authStorage.removeItem('token');
    authStorage.removeItem('refreshToken');
    authStorage.removeItem('user');
    window.location.href = '/login';
  },

  getUserProfile: async (email) => {
    return request(`/auth/user/${email}`, { method: 'GET' });
  },

  getAdminUsers: async () => {
    return request('/auth/admin/users', { method: 'GET' });
  },

  adminCreateUser: async (userData) => {
    return request('/auth/admin/users', {
      method: 'POST',
      body: JSON.stringify(userData)
    });
  },

  getAdminRoles: async () => {
    return request('/auth/admin/roles', { method: 'GET' });
  },

  updateUserRoles: async (email, roles) => {
    return request(`/auth/admin/users/${email}/roles`, {
      method: 'PUT',
      body: JSON.stringify({ roles })
    });
  },

  updateUserPassword: async (email, password) => {
    return request(`/auth/admin/users/${email}/password`, {
      method: 'PUT',
      body: JSON.stringify({ password })
    });
  },

  forgotPasswordRequest: async (mobileNo) => {
    return request('/auth/forgot-password/request', {
      method: 'POST',
      body: JSON.stringify({ mobileNo })
    });
  },

  forgotPasswordVerify: async (mobileNo, otp, newPassword) => {
    return request('/auth/forgot-password/verify', {
      method: 'POST',
      body: JSON.stringify({ mobileNo, otp, newPassword })
    });
  },

  adminDeleteUser: async (userId) => {
    return request(`/vendor/admin/users/${userId}`, { method: 'DELETE' });
  },

  updateProfileName: async (name) => {
    return request('/auth/profile/name', {
      method: 'PUT',
      body: JSON.stringify({ name })
    });
  },

  updateProfileLocation: async (state, city) => {
    return request('/auth/profile/location', {
      method: 'PUT',
      body: JSON.stringify({ state, city })
    });
  },

  requestEmailOtp: async (newEmail) => {
    return request('/auth/profile/email/request-otp', {
      method: 'POST',
      body: JSON.stringify({ newEmail })
    });
  },

  verifyEmailOtp: async (newEmail, otp) => {
    const res = await request('/auth/profile/email/verify-otp', {
      method: 'POST',
      body: JSON.stringify({ newEmail, otp })
    });

    if (res.success && res.data) {
      if (res.data.accessToken) authStorage.setItem('token', res.data.accessToken);
      if (res.data.refreshToken) authStorage.setItem('refreshToken', res.data.refreshToken);
      if (res.data.user) authStorage.setItem('user', JSON.stringify(res.data.user));
    }
    return res;
  },

  requestMobileOtp: async (newMobileNo) => {
    return request('/auth/profile/mobile/request-otp', {
      method: 'POST',
      body: JSON.stringify({ newMobileNo })
    });
  },

  verifyMobileOtp: async (newMobileNo, otp) => {
    const res = await request('/auth/profile/mobile/verify-otp', {
      method: 'POST',
      body: JSON.stringify({ newMobileNo, otp })
    });

    if (res.success && res.data && res.data.user) {
      authStorage.setItem('user', JSON.stringify(res.data.user));
    }
    return res;
  },

  uploadProfilePhoto: async (formData) => {
    const res = await request('/auth/profile/photo', {
      method: 'POST',
      body: formData,
    });

    if (res.success && res.data) {
      const stored = authStorage.getItem('user');
      if (stored) {
        const u = JSON.parse(stored);
        u.photoUrl = res.data.photoUrl || u.photoUrl;
        authStorage.setItem('user', JSON.stringify(u));
      }
    }
    return res;
  }
};

export default authService;

